@if (moduleData$ | async; as moduleData) {
    @if (moduleData.direction === 'horizontal') {
        <header
            class="flex min-h-[3.5rem] w-full items-center justify-between border-b border-[#E6E6E6] bg-white px-6 py-3"
        >
            <div class="module-details">
                <p class="flex items-center gap-2">
                    <span
                        class="flex w-fit rounded-full bg-primary-green/10 p-1.5 text-primary-green empty:hidden"
                        nz-icon
                        [nzType]="moduleData?.icon"
                    ></span>
                    <span class="text-bd-sm-700">{{ (moduleData?.name | translate) || 'Alternative text' }}</span>
                </p>
            </div>
            <div class="flex items-center gap-4">
                <ul class="module-navigation-links flex items-center">
                    @for (submodule of moduleData?.submodules; track submodule) {
                        <li>
                            <a
                                [routerLink]="submodule.href"
                                [queryParams]="submodule.params"
                                [routerLinkActive]="['navigation-item-active']"
                                [routerLinkActiveOptions]="{ exact: !!submodule.exactActive }"
                                class="navigation-item"
                                >{{ submodule?.title | translate }}</a
                            >
                        </li>
                    }
                </ul>
                <ng-container *ngTemplateOutlet="topbarSlot()" />
            </div>
        </header>
    }
}
